import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarOutlineIcon from '@mui/icons-material/StarOutline';

export const MAX_STARS = 5;

export const BANNER_SHOW_DELAY_MS = 1000;

export const STAR_ICON_SX = { color: 'secondary.main', fontSize: 22 } as const;

// Stable, non-index keys for rendering a fixed-length row of star icons.
export const STAR_POSITIONS = Array.from({ length: MAX_STARS }, (_, index) => `star-${index + 1}`);

export type StarType = 'full' | 'half' | 'empty';

export const STAR_ICONS: Record<StarType, typeof StarIcon> = {
  full: StarIcon,
  half: StarHalfIcon,
  empty: StarOutlineIcon,
};

export const roundRatingToHalfStar = (rating: number): number => {
  return Math.round(rating * 2) / 2;
};

export const getStarType = (rating: number, starIndex: number): StarType => {
  if (rating >= starIndex) {
    return 'full';
  }

  if (rating >= starIndex - 0.5) {
    return 'half';
  }

  return 'empty';
};

export const getStarTypes = (rating: number): StarType[] => {
  const roundedRating = roundRatingToHalfStar(rating);

  return Array.from({ length: MAX_STARS }, (_, index) => getStarType(roundedRating, index + 1));
};

export const formatRating = (rating: number): string => {
  return rating.toLocaleString('fi-FI', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
};
